import React from "react";
import { TransportOption } from "../../../models/financing-request/transport-option/TransportOption";
import PersonalPassengerTransportOption from "../../../models/financing-request/transport-option/PersonalPassengerTransportOption";
import { Grid, Typography } from "@material-ui/core";

interface Props {
  transportOption: TransportOption;
}

export default function PersonalPassengerTransportItem({
  transportOption
}: Props) {
  let personalPassengerTransportOption = transportOption as PersonalPassengerTransportOption;

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle2">
        {personalPassengerTransportOption.personalStudent != null ? (
          "Učenik se vozi s učenikom " +
          personalPassengerTransportOption.personalStudent.lastName +
          " " +
          personalPassengerTransportOption.personalStudent.firstName +
          " - " +
          personalPassengerTransportOption.personalStudent.oib
        ) : (
          <></>
        )}
      </Typography>
    </Grid>
  );
}
